import { useState, useEffect } from 'react'

// Fetches store downloads (App Store + Google Play) from the REST endpoint
// for the given inclusive ISO range. Auth token comes from localStorage,
// same as the Apollo link.
export default function useDownloads({ from, to }) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    const token = localStorage.getItem('token')
    fetch(`/api/v2/analytics/downloads?from=${from}&to=${to}`, {
      headers: { Authorization: token ? `Bearer ${token}` : '' }
    })
      .then(async res => {
        if (!res.ok) {
          const body = await res.json().catch(() => ({}))
          throw new Error(body.error || `HTTP ${res.status}`)
        }
        return res.json()
      })
      .then(json => {
        if (!cancelled) setData(json)
      })
      .catch(e => {
        if (!cancelled) {
          setError(e.message)
          setData(null)
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [from, to])

  return { data, loading, error }
}
